export default __webpack_public_path__ + "static/media/Animations_Bar7.a9b39b53.svg";